import React from 'react'
import { useParams } from 'react-router-dom'
import CaptainDashboard from '../captain/CaptainDashboard'
import { getCaptainDashboard } from '../../api/adminCaptains'

export default function AdminCaptainDashboard() {
  const { id } = useParams()
  const userId = Number(id)
  const fetchData = React.useCallback(() => getCaptainDashboard(userId), [userId])
  return <CaptainDashboard fetchData={fetchData} title="لوحة الكابتن (عرض إداري)" />
}
